import { uniqueId } from 'lodash';
import { useMemo } from 'react';

export const useId = (s = '') => {
  return useMemo(() => uniqueId(s), [s]);
};
